export default "__VITE_ASSET__B8X2h6dH__"